import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { camelToSentenceCase } from '../../utils/strings';

@Pipe({ name: 'appCamelToSentence' })
export class CamelToSentencePipe implements PipeTransform {
    transform(value: string): any {
        if (!value) {
            return value;
        }

        return camelToSentenceCase(value);
    }
}
